<template>
  <v-flex>
    <v-autocomplete
      v-model="inputValue"
      :disabled="disabled"
      :required="required"
      :rules="getRules()"
      item-value="value"
      item-text="label"
      :items="items"
      :label="label"
      :loading="loading"
      persistent-hint
      :readonly="readonly"
      @input="emitInput($event)"
    >
      <v-tooltip
        v-if="description && description.length > 0"
        slot="append"
        left
      >
        <v-icon slot="activator">info</v-icon>
        <div class="vjsf-tooltip" v-html="description"></div>
      </v-tooltip>
      <!-- begin ref buttons -->
      <v-tooltip
        v-if="refSpecs != null"
        :slot="
          refSpecs.selectBtn != null && refSpecs.selectBtn.placement != null
            ? refSpecs.selectBtn.placement
            : 'append'
        "
        color="white grey--text"
        left
      >
        <v-btn slot="activator" icon class="ma-0" @click="$emit('refShowList')">
          <v-icon>find_replace</v-icon>
        </v-btn>
        <div class="vjsf-tooltip">
          {{
            refSpecs.selectBtn != null && refSpecs.selectBtn.description != null
              ? refSpecs.selectBtn.description
              : 'Select'
          }}
        </div>
      </v-tooltip>
      <v-tooltip
        v-if="refSpecs != null"
        :slot="
          refSpecs.clearBtn != null && refSpecs.clearBtn.placement != null
            ? refSpecs.clearBtn.placement
            : 'append'
        "
        color="white grey--text"
        left
      >
        <v-btn
          slot="activator"
          icon
          class="ma-0"
          @click="$emit('refClearSelection')"
        >
          <v-icon>clear</v-icon>
        </v-btn>
        <div class="vjsf-tooltip">
          {{
            refSpecs.clearBtn != null && refSpecs.clearBtn.description != null
              ? refSpecs.clearBtn.description
              : 'Clear'
          }}
        </div>
      </v-tooltip>
      <!-- end ref buttons -->
    </v-autocomplete>
  </v-flex>
</template>

<script>
import { Utils } from '../../Utils'
import api from '../../APIService'

var utils = new Utils()

export default {
  name: 'SelectFromFunctionWidget',
  props: {
    //region function props
    entityId: {
      type: String,
      required: true
    },
    entryId: {
      type: String,
      required: true
    },
    functionName: {
      type: String,
      required: true
    },
    functionArgs: {
      type: Array,
      default: null
    },
    //endregion
    label: {
      type: String,
      default: null
    },
    // value: {
    //   type: [String, Number],
    //   default: null
    // },
    description: {
      type: String,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Object,
      default: null
    },
    hide: {
      type: Object,
      default: null
    },
    show: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      inputValue: this.value || null,
      items: [],
      loading: false
    }
  },
  created: function() {
    this.refreshValue()
  },
  methods: {
    refreshValue() {
      this.loading = true
      api
        .getFunctionValue(
          this.entityId,
          this.entryId,
          this.functionName,
          this.functionArgs
        )
        .then((response) => {
          if (!Array.isArray(response.data.result)) {
            throw new Error('Response is not array!')
          }
          this.items = response.data.result
          if (this.items.length > 0) {
            this.inputValue = this.items[0].value
            this.emitInput(this.inputValue)
          }
          this.loading = false
        })
        .catch((ex) => {
          console.log('Could not get function value: ' + ex)
          this.items = []
          this.loading = false
        })
    },
    emitInput: function(value) {
      this.$emit('input', value)
      if (this.hide) {
        this.$emit('hide', this.hide, value)
      }
      if (this.show) {
        this.$emit('show', this.show, value)
      }
    },
    getRules() {
      if (this.rules === undefined || this.rules === null) return
      var rules = []
      if (this.rules.required === true)
        rules = rules.concat(utils.getRequiredRules())
      return rules
    }
  }
}
</script>
